export class ModelSummaryEvent {
  constructor(
    public hash: string,
    public startTime: number,
    public endTime: number,
    public eventName: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-summary-event.ts